<template>
	<div :class="{ 'col-12 col-lg-4': !field.parent_id, 'col-12': field.parent_id}">
		<b-form-group id="example-input-group-4" description="">
		<label
			:for="'DateUploadExplicit' + field.form_field_id + personNumber"
			class="d-block col-form-label-sm"
		>
			{{ field.name }}
		</label>
		<b-form-input
			type="date"
			:value="value"
			:state="isValidate"
			@input="$emit('input', $event)"
			@change="$emit('change', $event)"
			@focus="$emit('focus', $event)"
			@blur="onBlur"
		/>
		<b-form-invalid-feedback id="input-4-live-feedback">
			Поле обязательно для заполнения
		</b-form-invalid-feedback>
		</b-form-group>
	</div>
</template>

<script>

export default {
	name: 'DateUploadExplicit',
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { type: String, default: null },
		personNumber: { default: null },
		group: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isValidate: null,
			mask: '##.##.####',
		};
	},
	methods: {
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 *
		 * Если какие-то поля имеют дополнительную валидацию - то они могут изменить true валидность на false.
		 * Но не могут изменить false на true. Т.к. валидация, приходящая из бэка - более приоритетная.
		 * И не могут изменить undefined на false. Например, если телефон не обязателен, а заполнен неправильно - он все равно true.
		 *
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			if (this.validDOB(this.value)) {
				this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			} else this.isValidate = false;
			return this.isValidate;
		},
		validDOB(dob) {
			const re = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
			return re.test(dob);
		},
		onBlur() {
			this.$emit('blur', this.value);
		},
	},

};
</script>

<style scoped>
.error {
	width: 100%;
	margin-top: 0.25rem;
	font-size: 80%;
	color: #dc3545;
}
</style>
